import { useEffect, useState } from "react";
import { Padder, SimpleButton, SimpleInputWithLabel, SimplePageTemplate } from "./SimpleElements"
import { useUser } from "../../../biz/hooks/entities/useUser";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DataHelper, Helpers } from "../../../biz/data/Helpers";
import { useAddNewOrganization } from "../../../biz/hooks/entities/useOrganization";
import { Dialog } from "../Dialog";
import { AddingNewOrganizationViewStateType } from "../../../biz/data/redux/uIReducer";
import { SimpleScreenBottom, SimpleScreenTop } from "./SimpleScreenBottom";
import { useAppData } from "../../../biz/data/useAppData";
import { Portal } from "../main/Portal";
import { useTranslation, Trans } from "react-i18next";
import { t } from "i18next";

export const LoginScreen = () => {

    const { t } = useTranslation();
    const user = useUser();
    const [searchParams, setSearchParams] = useSearchParams();

    const [code, setcode] = useState<string>("");
    const [disabled, setDisabled] = useState<boolean>(false);

    const onStart = async () => {
        const token = searchParams.get("token")?.trim();
        if (!!token) {
            setSearchParams(params => { params.delete("token"); return params; });
            if (token?.length === 22) {
                // console.log("Loggin in with token: ", token);
                await user.loginWithToken(token);
            }
        }
    }
    useEffect(() => { onStart(); }, []);


    const loginWithToken = async (code: string) => {
        const _code = code;
        setcode(_code);
        if (_code?.length === 22) {
            setDisabled(true);
            await user.loginWithToken(_code);
            setcode("");
            setDisabled(false);
        }
    }

    const addNewOrganization = useAddNewOrganization();

    //const viewState: AddingNewOrganizationViewStateType = "accountcreated" as AddingNewOrganizationViewStateType;
    const viewState: AddingNewOrganizationViewStateType = addNewOrganization.viewState;

    return (
        <div id="ui-simple">
            {viewState === "createaccount" && (
                <LoginScreenSectionCreateAccount />
            )}
            {viewState === "login" && (
                <LoginScreenSectionLogin />
            )}
            {viewState === "accountcreated" && (
                <LoginScreenSectionAccountCreated />
            )}
            <SimplePageTemplate hideBottom={true}>
                <div className="mt-128" style={{ height: "80vh" }}>

                    <div>
                        <label>{t("code")}</label>
                        <input
                            disabled={disabled}
                            style={{ opacity: disabled ? 0.5 : 1 }}
                            className="frm-input" type="text" placeholder={t("code")} value={code} onChange={async e => {
                                await loginWithToken(e.target.value);
                            }}
                            maxLength={50}
                        />
                    </div>
                    <div>
                        <button className="frm-button mt-16" onClick={async () => {
                            if (!!code) {
                                await user.loginWithToken(code);
                                setcode("");
                            }
                        }}>
                            {t("login")}
                        </button>
                    </div>
                </div>

            </SimplePageTemplate>
        </div>
    )
}

export const LoginScreenSectionCreateAccount = () => {
    const user = useUser();
    const addNewOrganization = useAddNewOrganization();
    const { t } = useTranslation();

    const [createDisabled, setCreateDisabled] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>();
    const onCreateAccountPress = async () => {
        setCreateDisabled(true);
        // await Helpers.delay(500);
        const resp = await user.createNewAccount(addNewOrganization.organizationEmail);
        if (resp?.success) {
            addNewOrganization.setViewState("accountcreated")
        } else {
            setErrorMessage(resp.message);
        }
        setCreateDisabled(false);
    }

    const nav = useNavigate();

    return (

        <div className="login-start-container">
            <SimpleScreenTop />

            <div className="hide-on-mobile">
                <Padder heightPx={64} />
                <div className="login-start-container2">
                    <div className="login-start-box">
                        <div>

                            <div className="login-start-back" onClick={() => nav(-1)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                    <path d="M0.523438 8.20429C0.328125 8.00898 0.25 7.77461 0.25 7.50117C0.25 7.26679 0.328125 7.03242 0.523438 6.83711L7.39844 0.274607C7.78906 -0.0769556 8.375 -0.0769556 8.72656 0.313669C9.07812 0.665232 9.07812 1.29023 8.6875 1.64179L3.49219 6.56367H16.8125C17.3203 6.56367 17.75 6.99336 17.75 7.50117C17.75 8.04804 17.3203 8.43867 16.8125 8.43867H3.49219L8.6875 13.3996C9.07812 13.7512 9.07812 14.3371 8.72656 14.7277C8.375 15.1184 7.78906 15.1184 7.39844 14.7668L0.523438 8.20429Z" fill="#9F8E73" />
                                </svg>
                            </div>
                            <div className="login-box" >
                                <h1>
                                    {t("createABusinessAccount")}
                                </h1>
                                <Padder heightPx={16} />

                                <Padder heightPx={32} />

                                <SimpleInputWithLabel
                                    value={addNewOrganization.organizationEmail}
                                    placeholder={t("yourEmail")}
                                    onChange={e => addNewOrganization.setOrganizationEmail(e?.toLowerCase()?.trim())}
                                    inputClass="email" />

                                <SimpleButton
                                    type="primarygreen"
                                    onClick={onCreateAccountPress}
                                    label={t("register")}
                                    disabled={!DataHelper.isEmail(addNewOrganization?.organizationEmail) || createDisabled === true}
                                    fullWidth={true}
                                    icon="letter"
                                    shape="bigpill"
                                />

                                <Padder heightPx={16} />
                                <div className="terms-and-conditions">
                                    <Trans
                                        i18nKey={"byCreatingAnAccountYouAccept_"}
                                        components={{
                                            termsofuse: (<a href="https://www.ohgarden.se/termsofservice" ></a>),
                                            integrity: (<a href="https://www.ohgarden.se/privacy" ></a>)
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="login-box-text">
                                <div className="header">
                                    {t("thisIsHowItWorks")}
                                </div>
                                <Padder heightPx={16} />
                                <div className="text">
                                    {t("loginScreenSectionCreateAccountText01")}
                                    <br /><br />

                                    {t("loginScreenSectionCreateAccountText02")}
                                    <br /><br />
                                    {t("loginScreenSectionCreateAccountText03")}
                                </div>
                            </div>
                            <Padder heightPx={120} />
                        </div>

                        <div className="image-box">
                            <img src="./gfx/login-phones.png" style={{ width: "641px", height: "auto" }} />
                        </div>
                    </div>

                </div>
            </div>

            <div className="hide-on-desktop">
                <div className="login-start-box">
                    <div>

                        <div className="login-box" >
                            <div className="login-start-back" onClick={() => nav(-1)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                    <path d="M0.523438 8.20429C0.328125 8.00898 0.25 7.77461 0.25 7.50117C0.25 7.26679 0.328125 7.03242 0.523438 6.83711L7.39844 0.274607C7.78906 -0.0769556 8.375 -0.0769556 8.72656 0.313669C9.07812 0.665232 9.07812 1.29023 8.6875 1.64179L3.49219 6.56367H16.8125C17.3203 6.56367 17.75 6.99336 17.75 7.50117C17.75 8.04804 17.3203 8.43867 16.8125 8.43867H3.49219L8.6875 13.3996C9.07812 13.7512 9.07812 14.3371 8.72656 14.7277C8.375 15.1184 7.78906 15.1184 7.39844 14.7668L0.523438 8.20429Z" fill="#9F8E73" />
                                </svg>
                            </div>
                            <h1>
                                {t("createABusinessAccount")}
                            </h1>

                            <Padder heightPx={32} />

                            <SimpleInputWithLabel
                                value={addNewOrganization.organizationEmail}
                                placeholder={t("yourEmail")}
                                onChange={e => addNewOrganization.setOrganizationEmail(e?.toLowerCase()?.trim())}
                                inputClass="email" />

                            <SimpleButton
                                type="primarygreen"
                                onClick={onCreateAccountPress}
                                label={t("register")}
                                disabled={!DataHelper.isEmail(addNewOrganization?.organizationEmail) || createDisabled === true}
                                fullWidth={true}
                                icon="letter"
                                shape="bigpill"
                            />

                            <Padder heightPx={16} />
                            <div className="terms-and-conditions">
                                <Trans
                                    i18nKey={"byCreatingAnAccountYouAccept_"}
                                    components={{
                                        termsofuse: (<a href="https://www.ohgarden.se/termsofservice" ></a>),
                                        integrity: (<a href="https://www.ohgarden.se/privacy" ></a>)
                                    }}
                                />
                            </div>
                        </div>
                        <div className="login-box-text">
                            <div className="header">
                                {t("thisIsHowItWorks")}
                            </div>
                            <Padder heightPx={16} />
                            <div className="text">
                                {t("loginScreenSectionCreateAccountText01")}
                                <br /><br />

                                {t("loginScreenSectionCreateAccountText02")}
                                <br /><br />
                                {t("loginScreenSectionCreateAccountText03")}
                            </div>
                        </div>


                        <Padder heightPx={40} />
                        <div className="image-box-mobile">

                            <img src="./gfx/login-phones.png" style={{ width: "641px", height: "auton" }} />
                        </div>
                    </div>
                </div>
            </div>

            <SimpleScreenBottom />
            <Dialog visible={!!errorMessage}
                onOk={() => setErrorMessage(undefined)}
                onCancel={() => setErrorMessage(undefined)}
                type="warning"
                clickOutside={() => setErrorMessage(undefined)}
            >
                {errorMessage}
            </Dialog>
        </div>

    )
}
export const LoginScreenSectionLogin = () => {
    const user = useUser();
    const addNewOrganization = useAddNewOrganization();
    const { t } = useTranslation();

    const [createDisabled, setCreateDisabled] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>();
    const onLoginToAccountPress = async () => {
        setCreateDisabled(true);
        // await Helpers.delay(500);
        const resp = await user.sendLoginlink(addNewOrganization.organizationEmail);
        if (resp?.success) {
            addNewOrganization.setViewState("accountcreated")
        } else {
            setErrorMessage(resp.message);
        }
        setCreateDisabled(false);
    }

    const nav = useNavigate();

    return (
        <div className="login-start-container">
            <SimpleScreenTop />

            <div className="hide-on-mobile">
                <Padder heightPx={64} />

                <div className="login-start-container2">
                    <div className="login-start-box" style={{ height: "900px" }}>
                        <div>

                            <div className="login-start-back" onClick={() => nav(-1)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                                    <path d="M0.523438 8.20429C0.328125 8.00898 0.25 7.77461 0.25 7.50117C0.25 7.26679 0.328125 7.03242 0.523438 6.83711L7.39844 0.274607C7.78906 -0.0769556 8.375 -0.0769556 8.72656 0.313669C9.07812 0.665232 9.07812 1.29023 8.6875 1.64179L3.49219 6.56367H16.8125C17.3203 6.56367 17.75 6.99336 17.75 7.50117C17.75 8.04804 17.3203 8.43867 16.8125 8.43867H3.49219L8.6875 13.3996C9.07812 13.7512 9.07812 14.3371 8.72656 14.7277C8.375 15.1184 7.78906 15.1184 7.39844 14.7668L0.523438 8.20429Z" fill="#9F8E73" />
                                </svg>
                            </div>
                            <div className="login-box br" >
                                <h1>
                                    {t("login")}
                                </h1>
                                <Padder heightPx={16} />

                                <Padder heightPx={32} />

                                <SimpleInputWithLabel
                                    value={addNewOrganization.organizationEmail}
                                    placeholder={t("yourEmail")}
                                    onChange={e => addNewOrganization.setOrganizationEmail(e?.toLowerCase()?.trim())}
                                    inputClass="email" />

                                <SimpleButton
                                    type="primarygreen"
                                    onClick={onLoginToAccountPress}
                                    label={t("logInWithEmail")}
                                    disabled={!DataHelper.isEmail(addNewOrganization?.organizationEmail) || createDisabled === true}
                                    fullWidth={true}
                                    icon="letter"
                                    shape="bigpill"
                                />
                            </div>
                        </div>

                        <div className="image-box">

                            <img src="./gfx/login-phones.png" style={{ width: "641px", height: "auton" }} />
                        </div>
                    </div>
                </div>

                <Padder heightPx={500} />
            </div>

            <div className="hide-on-desktop">

                <div className="login-start-box-mobile br" >

                    <div className="login-start-back" onClick={() => nav(-1)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                            <path d="M0.523438 8.20429C0.328125 8.00898 0.25 7.77461 0.25 7.50117C0.25 7.26679 0.328125 7.03242 0.523438 6.83711L7.39844 0.274607C7.78906 -0.0769556 8.375 -0.0769556 8.72656 0.313669C9.07812 0.665232 9.07812 1.29023 8.6875 1.64179L3.49219 6.56367H16.8125C17.3203 6.56367 17.75 6.99336 17.75 7.50117C17.75 8.04804 17.3203 8.43867 16.8125 8.43867H3.49219L8.6875 13.3996C9.07812 13.7512 9.07812 14.3371 8.72656 14.7277C8.375 15.1184 7.78906 15.1184 7.39844 14.7668L0.523438 8.20429Z" fill="#9F8E73" />
                        </svg>
                    </div>

                    <h1>
                        {t("login")}
                    </h1>
                    <Padder heightPx={16} />



                    <Padder heightPx={32} />

                    <SimpleInputWithLabel
                        value={addNewOrganization.organizationEmail}
                        placeholder={t("yourEmail")}
                        onChange={e => addNewOrganization.setOrganizationEmail(e?.toLowerCase()?.trim())}
                        inputClass="email" />

                    <SimpleButton
                        type="primarygreen"
                        onClick={onLoginToAccountPress}
                        label={t("logInWithEmail")}
                        disabled={!DataHelper.isEmail(addNewOrganization?.organizationEmail) || createDisabled === true}
                        fullWidth={true}
                        icon="letter"
                        shape="bigpill"
                    />
                </div>

                <Padder heightPx={40} />
                <div className="image-box-mobile">

                    <img src="./gfx/login-phones.png" style={{ width: "641px", height: "auton" }} />
                </div>
            </div>

            <SimpleScreenBottom />
            <Dialog visible={!!errorMessage}
                onOk={() => setErrorMessage(undefined)}
                onCancel={() => setErrorMessage(undefined)}
                type="warning"
                clickOutside={() => setErrorMessage(undefined)}
            >
                {errorMessage}
            </Dialog>

        </div>
    )
}


export const LoginScreenSectionAccountCreated = () => {
    const addNewOrganization = useAddNewOrganization();
    const supportEmail = useAppData().supportEmail;
    const { t } = useTranslation();

    const onCreateAccountPress = async () => {

        //await user.loginWithCredentials(credentials?.email, credentials?.pwd);
        addNewOrganization.setViewState("accountcreated")
    }

    return (

        <div className="login-start-container">
            <SimpleScreenTop />
            <Padder heightPx={64} />

            <div className="login-start-container2">
                <div className="login-start-box" style={{ marginBottom: "64px" }}>
                    <div className="login-box margin-when-desktop" style={{ borderRadius: "16px" }}>
                        <h1>
                            {t("validateYourEmail")}
                        </h1>
                        <Padder heightPx={32} />

                        <div className="text-para">
                            {t("weHaveNowSentAnEmailToYourEmailAddress")}
                        </div>

                        <Padder heightPx={8} />
                        <div className="text-para-bold">
                            {!!addNewOrganization?.organizationEmail ? addNewOrganization?.organizationEmail : "namn@foretag.com"}
                        </div>
                        <Padder heightPx={8} />

                        <div className="text-para">
                            {t("clickOnTheLinkInTheEmailToValidateThatEverythingWasCorrect")}
                        </div>
                        <hr />
                        <div className="text-para-small">
                            <Trans
                                i18nKey="ifYouHavenTReceivedAnEmailWithinThreeMinutes_"
                                components={{
                                    supportlink: (<a href={"mailto:" + supportEmail}>{supportEmail}</a>)
                                }}
                            />
                        </div>

                    </div>

                    <div className="image-box">
                        <img src="./gfx/login-phones.png" style={{ width: "641px", height: "auton" }} />
                    </div>
                    <Padder heightPx={256} />
                </div>
            </div>

            <SimpleScreenBottom />
        </div>

    )
}

export const LoginLogo = () => {
    return (
        <svg width="244" height="84" viewBox="0 0 244 84" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.338627 66.7741C0.316029 64.4107 0.81395 62.0713 1.79705 59.9219C2.71921 57.8962 3.98839 56.0472 5.54727 54.4586C7.03366 52.9444 8.78286 51.7129 10.7096 50.8241C12.5044 49.9714 14.4637 49.5211 16.4507 49.5046C18.5055 49.5088 20.5349 49.959 22.3988 50.8241C24.3296 51.7057 26.0801 52.9381 27.5611 54.4586C29.0987 56.0404 30.3308 57.8925 31.1956 59.9219C32.1193 62.0871 32.5844 64.4202 32.5614 66.7741C32.5585 68.9494 32.134 71.1034 31.3113 73.1171C30.5047 75.1421 29.3446 77.0077 27.8852 78.6267C26.4366 80.23 24.7016 81.5489 22.7692 82.5158C20.8096 83.5031 18.6435 84.0109 16.4493 83.9974C14.2227 84.0167 12.0212 83.5258 10.0138 82.5621C8.07585 81.6344 6.33792 80.3368 4.89772 78.7424C3.4477 77.1293 2.30954 75.2612 1.54104 73.2329C0.742979 71.1732 0.335231 68.983 0.338627 66.7741ZM5.66302 66.7741C5.63572 69.2087 5.82163 71.641 6.21861 74.0431C6.5022 75.8732 7.13064 77.6329 8.07057 79.2286C8.86846 80.556 10.0249 81.6313 11.4068 82.3306C12.9871 83.0576 14.7148 83.4072 16.4534 83.3519C18.1842 83.4022 19.9032 83.0527 21.4769 82.3306C22.8673 81.6359 24.0315 80.56 24.8335 79.2286C25.7732 77.6327 26.4016 75.8731 26.6855 74.0431C27.0825 71.641 27.2684 69.2087 27.2411 66.7741C27.2452 64.7078 27.106 62.6437 26.8244 60.5966C26.5892 58.7457 26.0495 56.9464 25.2271 55.2715C24.4809 53.7582 23.3454 52.4706 21.9371 51.5411C20.2846 50.5488 18.3763 50.0657 16.4507 50.1521C14.5251 50.0657 12.6168 50.5488 10.9643 51.5411C9.55714 52.4696 8.42255 53.7561 7.67703 55.2682C6.85428 56.944 6.31455 58.7445 6.07971 60.5966C5.79812 62.6437 5.65889 64.7078 5.66302 66.7741Z" fill="#3E4B43" />
            <path d="M38.6272 82.6566H42.1923V50.5693H38.6272V49.9211H46.174V68.1166H46.2666C46.4843 67.5929 46.7477 67.0894 47.0537 66.6119C47.4629 65.9659 47.9706 65.3879 48.5584 64.8988C49.2547 64.3206 50.0354 63.8522 50.8733 63.5099C51.9116 63.1003 53.0216 62.9035 54.1374 62.9311C55.9158 62.852 57.669 63.3739 59.1146 64.4127C60.3955 65.4004 61.036 66.9746 61.036 69.1352V82.6566H64.601V83.3048H53.4892V82.6566H57.055V67.6999C57.0992 66.6454 56.7985 65.6051 56.1984 64.7368C55.8831 64.341 55.4755 64.0285 55.0114 63.8267C54.5473 63.6249 54.0408 63.54 53.5362 63.5793C52.5577 63.5774 51.5917 63.7991 50.712 64.2275C49.8112 64.664 49.008 65.2782 48.3507 66.0332C47.6527 66.8371 47.1107 67.7642 46.7527 68.7669C46.3583 69.8656 46.1624 71.0257 46.174 72.193V82.6566H49.739V83.3048H38.6272V82.6566Z" fill="#3E4B43" />
            <path d="M73.9534 78.9041C73.3864 78.9047 72.8371 79.1019 72.3992 79.462C71.9613 79.8221 71.6617 80.3229 71.5516 80.8791C71.4414 81.4353 71.5275 82.0124 71.7951 82.5123C72.0628 83.0121 72.4954 83.4037 73.0194 83.6204C73.5433 83.837 74.1262 83.8653 74.6687 83.7005C75.2112 83.5356 75.6797 83.1878 75.9945 82.7162C76.3094 82.2447 76.451 81.6786 76.3952 81.1143C76.3395 80.5501 76.0899 80.0226 75.6889 79.6218C75.4638 79.3901 75.1938 79.207 74.8953 79.0835C74.5969 78.9601 74.2763 78.8991 73.9534 78.9041Z" fill="#3E4B43" />
            <path d="M99.119 18.1055C99.0991 17.909 99.0114 17.7256 98.8711 17.5867L98.8534 17.5703L98.8391 17.5574C98.6937 17.4266 98.5075 17.3501 98.3121 17.3409C98.2621 17.338 98.2119 17.3403 98.1624 17.3477C98.0989 17.3559 98.0365 17.3712 97.9765 17.3933C90.8226 19.8792 86.7694 23.9188 84.5327 27.1862C84.6008 26.5735 84.707 25.6202 84.863 24.3995C86.5441 22.7833 87.9148 20.8728 88.9073 18.7625C90.6721 15.0824 92.2204 8.94237 89.5766 0.589481C89.5625 0.552739 89.5459 0.51702 89.5269 0.482585C89.5181 0.463521 89.5112 0.444456 89.5004 0.425392C89.4537 0.342976 89.3933 0.269074 89.322 0.206833C89.307 0.193897 89.29 0.183684 89.2736 0.172109C89.2033 0.117983 89.1247 0.075669 89.0408 0.0468292C89.0292 0.042744 89.0217 0.0338928 89.0101 0.0304884C88.9986 0.0270841 89.0013 0.0304884 88.9965 0.0304884C88.9917 0.0304884 88.9822 0.0243606 88.9747 0.022318C88.8856 0.00125095 88.7935 -0.00496031 88.7024 0.00393454C88.6799 0.00393454 88.6588 0.00938149 88.6343 0.0127858C88.545 0.0255995 88.4584 0.0524874 88.3776 0.0924474C88.3708 0.0958518 88.3626 0.0972135 88.3558 0.101299C88.2888 0.138402 88.227 0.184188 88.172 0.237472C88.0515 0.353901 76.1887 12.0049 83.0478 24.6126C83.0661 24.6423 83.0861 24.6709 83.1077 24.6984C82.8687 26.6123 82.7598 27.7623 82.7563 27.8011C82.115 33.7927 80.9636 35.2709 79.222 37.5116C78.7324 38.1421 78.185 38.8516 77.5933 39.7272C77.6961 36.2227 76.9567 31.1257 73.5224 24.8631C73.4886 24.7986 73.4467 24.7387 73.3978 24.6847C73.3647 24.6482 73.3285 24.6147 73.2896 24.5846C73.1994 24.5142 73.096 24.4626 72.9854 24.4331C72.8749 24.4037 72.7595 24.3968 72.6462 24.413C72.533 24.4292 72.4242 24.4682 72.3263 24.5275C72.2285 24.5868 72.1437 24.6653 72.0769 24.7583C72.0359 24.8144 72.002 24.8755 71.9762 24.9401C70.7745 27.9497 69.9423 31.094 69.4978 34.304C68.5664 41.1522 69.8879 46.7299 73.3107 50.4658C72.1212 57.1172 72.3683 65.1726 72.5855 72.0289L72.64 73.7958C72.6466 74.017 72.739 74.2269 72.8978 74.3811C73.0565 74.5353 73.2691 74.6216 73.4904 74.6217H73.5163C73.628 74.6184 73.7379 74.5932 73.8399 74.5474C73.9418 74.5016 74.0337 74.4362 74.1103 74.3549C74.187 74.2736 74.2468 74.1779 74.2865 74.0735C74.3262 73.969 74.3448 73.8578 74.3415 73.7461L74.287 71.9758C74.0086 63.1803 73.6273 51.1331 76.9131 44.3414C77.8971 42.2748 79.1226 40.3321 80.5639 38.554C81.1143 37.8724 81.6267 37.161 82.0986 36.4229C87.1922 35.8871 91.7445 32.6046 95.2693 26.9132C96.9002 24.2646 98.1818 21.4163 99.0822 18.4391C99.101 18.3774 99.1124 18.3136 99.1162 18.2492C99.121 18.2014 99.122 18.1534 99.119 18.1055ZM72.162 29.8062L73.1091 47.3726C69.7776 41.8916 70.9256 34.4218 72.162 29.8062ZM73.8499 29.4903C77.5082 38.5356 75.1034 44.2086 75.0612 44.3053C75.0537 44.3306 75.0478 44.3563 75.0435 44.3823C74.925 44.6594 74.8065 44.9358 74.6976 45.2238L73.8499 29.4903ZM85.2619 21.4656C86.0879 15.6074 87.2473 9.80104 88.7344 4.07485C90.5979 12.9009 87.5054 18.642 85.2619 21.4656ZM86.8702 4.46975C85.4509 10.094 84.3372 15.791 83.5339 21.5357C81.0113 14.5555 84.304 8.09061 86.8702 4.46975ZM94.8955 20.5382L83.7879 32.3363C84.3904 30.5892 86.9791 24.5288 94.8955 20.5362V20.5382ZM84.3421 34.2332L95.9945 21.855C94.1425 26.0274 90.4325 32.32 84.3414 34.2312L84.3421 34.2332Z" fill="#3E4B43" />
            <path d="M114.997 71.4965H111.293V82.0064H110.737C110.489 81.7419 110.209 81.5086 109.904 81.3119C109.584 81.1675 109.233 81.1039 108.883 81.1267C108.292 81.1358 107.713 81.2867 107.193 81.5665C106.622 81.8607 105.958 82.1925 105.202 82.562C104.345 82.9702 103.454 83.3032 102.54 83.5574C101.331 83.8744 100.085 84.0224 98.8358 83.9972C96.8377 84.0333 94.8532 83.6627 93.0028 82.9078C91.1613 82.0827 89.4952 80.9118 88.0951 79.4586C86.5165 77.866 85.2171 76.0191 84.2516 73.9953C83.2082 71.7826 82.6855 69.3603 82.7237 66.9142C82.7034 65.3121 82.9061 63.7148 83.3263 62.1686C83.6759 60.8919 84.1649 59.6575 84.7847 58.4878C85.2803 57.5508 85.8698 56.6666 86.5441 55.8488C87.1455 55.1393 87.6471 54.5837 88.0488 54.182C89.4354 52.7945 91.0468 51.6517 92.8149 50.8022C94.7273 49.9123 96.8174 49.4699 98.9264 49.5085C99.8985 49.4881 100.87 49.5814 101.82 49.7863C102.491 49.9442 103.148 50.1532 103.787 50.4114C104.344 50.6429 104.845 50.8512 105.292 51.0364C105.771 51.2276 106.282 51.322 106.797 51.3142C107.252 51.3495 107.708 51.2615 108.117 51.0595C108.408 50.8628 108.666 50.6205 108.88 50.3419H109.574V59.6017H109.073C108.91 58.6427 108.67 57.6982 108.356 56.7775C107.979 55.6569 107.415 54.6081 106.688 53.6754C105.873 52.6387 104.847 51.7866 103.679 51.1753C102.191 50.4423 100.544 50.0913 98.8869 50.154C96.9218 50.0585 94.9747 50.5675 93.3078 51.6124C91.8998 52.5893 90.7676 53.9129 90.0206 55.4552C89.2017 57.1539 88.6697 58.9765 88.4464 60.8491C88.1841 62.8601 88.0529 64.8861 88.0536 66.9142C88.0536 68.3032 88.1153 69.6922 88.2388 71.0812C88.3511 72.4064 88.56 73.7217 88.8638 75.0166C89.1385 76.2022 89.5498 77.3519 90.0894 78.4427C90.59 79.4603 91.2819 80.372 92.1272 81.1281C92.9519 81.9012 93.9296 82.4926 94.9971 82.8643C96.2453 83.2235 97.5416 83.3875 98.8399 83.3504C99.8172 83.347 100.787 83.1827 101.711 82.8643C102.653 82.5479 103.526 82.0527 104.281 81.4059C105.065 80.7196 105.696 79.8756 106.132 78.9289C106.634 77.8174 106.879 76.6074 106.85 75.3883V71.4992H100.878V70.851H114.997V71.4965Z" fill="#3E4B43" />
            <path d="M139.908 82.7926C139.467 83.124 138.984 83.3964 138.472 83.6029C137.823 83.8511 137.131 83.9691 136.435 83.9501C134.954 83.9501 133.881 83.6337 133.217 83.001C132.503 82.2726 132.026 81.3441 131.852 80.3388H131.759C131.635 80.6166 131.465 80.9638 131.25 81.3805C130.997 81.8412 130.659 82.2497 130.254 82.5843C129.725 83.0157 129.121 83.3454 128.472 83.5566C127.559 83.8442 126.604 83.9772 125.648 83.9501C124.596 83.987 123.546 83.8381 122.546 83.5103C121.873 83.2787 121.258 82.9074 120.74 82.4209C120.327 82.0217 120.031 81.5174 119.883 80.9624C119.751 80.4716 119.681 79.966 119.675 79.4577C119.63 78.5484 119.855 77.6461 120.323 76.865C120.753 76.219 121.333 75.6868 122.013 75.314C122.747 74.9121 123.523 74.5937 124.328 74.3648C125.176 74.1184 126.033 73.856 126.898 73.5777C127.916 73.2387 128.757 72.9454 129.421 72.6981C129.994 72.505 130.521 72.1979 130.972 71.7952C131.349 71.4293 131.614 70.9636 131.736 70.4526C131.893 69.7305 131.963 68.9921 131.944 68.2533C131.951 67.5872 131.905 66.9216 131.808 66.2625C131.735 65.7333 131.562 65.2227 131.299 64.7578C131.05 64.3394 130.678 64.0079 130.234 63.8086C129.647 63.5701 129.015 63.4598 128.382 63.4852C127.51 63.4528 126.643 63.6354 125.859 64.017C125.541 64.1776 125.278 64.4276 125.101 64.7361C124.924 65.0447 124.842 65.3982 124.863 65.7532C124.862 66.2732 124.907 66.7924 124.999 67.3042C125.075 67.678 125.121 68.0574 125.136 68.4385C125.14 68.6425 125.101 68.8451 125.021 69.0329C124.941 69.2207 124.822 69.3894 124.673 69.5279C124.299 69.8438 123.818 70.0015 123.33 69.9678C122.311 69.9678 121.679 69.7826 121.432 69.4122C121.168 68.9813 121.039 68.4815 121.061 67.9769C121.06 67.3013 121.219 66.635 121.524 66.0324C121.855 65.3905 122.323 64.8295 122.895 64.3894C123.573 63.8723 124.343 63.4875 125.163 63.2551C126.179 62.9628 127.232 62.8224 128.289 62.8384C129.499 62.8058 130.706 62.9861 131.854 63.3708C132.723 63.6711 133.513 64.1614 134.169 64.8061C134.737 65.3796 135.165 66.0768 135.419 66.8433C135.667 67.613 135.792 68.4174 135.789 69.2263V80.7548C135.719 81.3865 135.866 82.0232 136.206 82.5604C136.361 82.7203 136.549 82.8445 136.757 82.9245C136.965 83.0044 137.187 83.0382 137.41 83.0234C137.772 83.0197 138.132 82.9571 138.474 82.8382C138.856 82.7093 139.215 82.5219 139.539 82.2826L139.908 82.7926ZM131.805 71.9586H131.713C131.65 72.3604 131.141 72.7616 130.185 73.1624L126.712 74.5514C125.811 74.8875 125.024 75.4737 124.444 76.2413C123.898 77.0363 123.622 77.9859 123.657 78.9498C123.658 79.4314 123.703 79.9119 123.793 80.3851C123.876 80.8538 124.049 81.3019 124.302 81.7046C124.563 82.1044 124.922 82.431 125.344 82.6537C125.882 82.9215 126.479 83.0489 127.08 83.0241C127.952 83.064 128.816 82.838 129.557 82.3759C130.168 81.969 130.662 81.4107 130.992 80.7555C131.321 80.0928 131.539 79.3814 131.641 78.6489C131.743 77.9667 131.797 77.2783 131.803 76.5885L131.805 71.9586Z" fill="#3E4B43" />
            <path d="M143.055 82.6565H146.621V64.0885H143.055V63.4403H150.51V68.1165H150.602C150.755 67.5749 150.957 67.048 151.204 66.5424C151.503 65.9243 151.893 65.3547 152.362 64.8524C152.873 64.2984 153.476 63.8367 154.144 63.4873C154.926 63.0961 155.793 62.905 156.667 62.931C157.302 62.9166 157.933 63.0349 158.519 63.2783C159.004 63.4838 159.444 63.7827 159.813 64.158C160.148 64.5063 160.401 64.925 160.554 65.3835C160.705 65.831 160.784 66.3001 160.785 66.7725C160.785 67.7911 160.554 68.4701 160.091 68.8097C159.621 69.1519 159.052 69.3307 158.47 69.3189C157.112 69.3189 156.433 68.8877 156.433 68.0253C156.426 67.7979 156.457 67.5708 156.526 67.354C156.587 67.1847 156.657 67.0149 156.734 66.8447C156.817 66.6569 156.887 66.4635 156.942 66.2659C157.014 65.9626 157.045 65.6513 157.035 65.34C157.035 64.3527 156.495 63.8588 155.415 63.8584C154.846 63.8834 154.298 64.0768 153.84 64.414C153.223 64.8481 152.696 65.3986 152.289 66.0344C151.77 66.8307 151.365 67.6956 151.086 68.604C150.745 69.7215 150.581 70.8853 150.6 72.0533V82.6565H154.628V83.3047H143.053L143.055 82.6565Z" fill="#3E4B43" />
            <path d="M177.456 49.9211H185.002V82.6566H188.567V83.3048H181.113V79.2767H181.021C180.861 79.7345 180.675 80.1827 180.465 80.6194C180.188 81.1851 179.82 81.7013 179.376 82.1473C178.852 82.6728 178.241 83.1036 177.57 83.4205C176.735 83.7979 175.824 83.98 174.908 83.953C173.569 83.9574 172.247 83.6565 171.042 83.0733C169.831 82.4942 168.74 81.6933 167.824 80.712C166.893 79.7178 166.149 78.5648 165.625 77.3077C164.552 74.7386 164.544 71.8486 165.602 69.2734C166.594 66.8292 168.458 64.8407 170.833 63.6937C172.001 63.1238 173.284 62.8307 174.583 62.8372C176.06 62.768 177.515 63.2094 178.704 64.0873C179.72 64.8748 180.49 65.9345 180.927 67.143H181.019V50.5693H177.454L177.456 49.9211ZM169.446 72.7002C169.446 74.3057 169.491 75.7642 169.582 77.0755C169.639 78.2235 169.874 79.3557 170.277 80.4322C170.599 81.2973 171.181 82.0414 171.943 82.5619C172.891 83.0637 173.95 83.3183 175.022 83.3021C176.095 83.2859 177.146 82.9995 178.078 82.4693C178.861 81.9188 179.49 81.1778 179.907 80.3164C180.353 79.3888 180.65 78.3966 180.786 77.3764C180.938 76.3338 181.015 75.2817 181.018 74.2281C181.018 73.0243 180.995 71.9826 180.95 71.1029C180.914 70.319 180.829 69.5381 180.695 68.7648C180.593 68.1609 180.422 67.5706 180.186 67.0055C179.972 66.5168 179.708 66.0513 179.399 65.6165C178.915 64.982 178.299 64.4606 177.593 64.0886C176.716 63.6572 175.745 63.4506 174.768 63.4874C173.838 63.4497 172.916 63.6741 172.107 64.1349C171.399 64.5824 170.836 65.2257 170.486 65.9869C170.068 66.9036 169.794 67.8798 169.675 68.8806C169.513 70.1472 169.436 71.4233 169.446 72.7002Z" fill="#3E4B43" />
            <path d="M198.382 71.8207C198.382 72.1298 198.374 72.4461 198.359 72.7698C198.344 73.0934 198.336 73.5019 198.336 73.9953C198.338 75.0628 198.4 76.1294 198.521 77.19C198.625 78.2307 198.899 79.2473 199.331 80.1994C199.743 81.0898 200.382 81.8562 201.183 82.4218C202.152 83.0511 203.294 83.3589 204.447 83.3015C205.596 83.341 206.74 83.1359 207.804 82.6996C208.592 82.3636 209.302 81.8669 209.887 81.2411C210.359 80.7288 210.742 80.1422 211.022 79.5049C211.268 78.9194 211.453 78.441 211.577 78.0697L212.272 78.2058C212.123 78.702 211.945 79.1889 211.739 79.6643C211.434 80.3635 211.011 81.0055 210.489 81.5625C209.83 82.2596 209.045 82.8252 208.174 83.2293C206.987 83.7511 205.697 83.9965 204.401 83.9469C202.94 83.9614 201.489 83.7104 200.118 83.2061C198.848 82.7396 197.689 82.0143 196.714 81.0764C195.75 80.1405 194.993 79.0127 194.492 77.766C193.951 76.4037 193.684 74.9487 193.705 73.4833C193.705 72.1227 193.98 70.7761 194.515 69.5248C195.577 66.9759 197.549 64.9131 200.048 63.7374C202.189 62.7101 204.645 62.5525 206.9 63.2975C207.906 63.6169 208.842 64.1278 209.655 64.8023C210.552 65.5594 211.277 66.4984 211.784 67.5571C212.396 68.8915 212.689 70.3496 212.641 71.8166L198.382 71.8207ZM207.92 71.1725C207.979 70.7739 208.01 70.3716 208.012 69.9687V68.8112C208.034 67.9372 207.932 67.0644 207.711 66.2185C207.554 65.6243 207.27 65.0713 206.878 64.598C206.531 64.2023 206.084 63.9066 205.584 63.7415C205.054 63.5691 204.499 63.4833 203.941 63.4875C203.035 63.4511 202.138 63.6673 201.348 64.1119C200.671 64.5261 200.113 65.1082 199.728 65.8018C199.305 66.5686 199 67.395 198.825 68.2529C198.619 69.2137 198.487 70.1888 198.431 71.1697L207.92 71.1725Z" fill="#3E4B43" />
            <path d="M217.689 82.6564H221.254V64.0884H217.689V63.4402H225.143V68.3942H225.236C225.421 67.9939 225.691 67.4846 226.046 66.8664C226.442 66.1971 226.933 65.5888 227.504 65.0607C228.267 64.3485 229.162 63.7937 230.139 63.4283C231.117 63.0628 232.156 62.8938 233.199 62.9309C234.977 62.8518 236.731 63.3737 238.176 64.4125C239.456 65.4002 240.097 66.9744 240.098 69.135V82.6564H243.663V83.3046H232.551V82.6564H236.116V67.6997C236.16 66.6452 235.859 65.6049 235.259 64.7366C234.944 64.3408 234.536 64.0284 234.072 63.8266C233.608 63.6248 233.102 63.5398 232.597 63.5791C231.619 63.5771 230.653 63.7988 229.773 64.2273C228.872 64.6637 228.069 65.2779 227.412 66.033C226.714 66.8368 226.172 67.7639 225.814 68.7667C225.42 69.8653 225.224 71.0255 225.236 72.1928V82.6564H228.801V83.3046H217.689V82.6564Z" fill="#3E4B43" />
        </svg>
    )
}